<template lang="pug">
.v-cars-btns.cars-btns(v-if="block")
	.cars-btns__container
		.cars-btns__wrapper
			template(v-if="block.items && block.items.length"
					v-for="(btn, btnIndex) in block.items"
					:key="btnIndex")
				a.cars-btns__item(:href="btn.link")
					.cars-btns__item-main
						img.cars-btns__main-img(v-if="btn.image"
								:src="btn.image"
								alt=""
								loading="lazy")
						.cars-btns__main-text(v-if="btn.text") {{btn.text}}
					v-svg-icon.cars-btns__main-pointer(icon="pointer-right")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import VSvgIcon from 'components/helpers/v-svg-icon.vue';

export default {
	mixins: [
		sourceMixin
	],

	data() {
		return {
			block: null,
		}
	},

	methods: {
		dataSet(data) {
			this.block = data;
		}
	}
};
</script>